import React, { createContext, useContext, useReducer } from "react";

// Event status types
type EventStatus = "idle" | "loading" | "success" | "error";
export type { EventStatus };
export type EventStatusState = Record<string, EventStatus>;
export type EventStatusAction =
  | { type: "SET_STATUS"; id: string; status: EventStatus }
  | { type: "RESET" };

function eventStatusReducer(
  state: EventStatusState,
  action: EventStatusAction,
): EventStatusState {
  switch (action.type) {
    case "SET_STATUS":
      console.log("Setting status for event", action.id, "to", action.status);
      return { ...state, [action.id]: action.status };
    case "RESET":
      return {};
    default:
      return state;
  }
}

const EventStatusContext = createContext<
  | {
      state: EventStatusState;
      dispatch: React.Dispatch<EventStatusAction>;
    }
  | undefined
>(undefined);

export function useEventStatus() {
  const ctx = useContext(EventStatusContext);
  if (!ctx)
    throw new Error("useEventStatus must be used within EventStatusProvider");
  return ctx;
}

/**
 * Hook to get the status of an event by id from the context.
 */
export function useEventStatusById(id: string): EventStatus {
  const { state } = useEventStatus();
  return state[id] || "idle";
}

export function EventStatusProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [eventStatus, eventStatusDispatch] = useReducer(eventStatusReducer, {});
  return (
    <EventStatusContext.Provider
      value={{ state: eventStatus, dispatch: eventStatusDispatch }}
    >
      {children}
    </EventStatusContext.Provider>
  );
}
